<template>
  <div class="register">
    <div class="title">
      {{ loginConfig.title }}
      <!-- 欢迎来到“多测合一”网上办事大厅 -->
    </div>
    <van-tabs v-model="fromData.accountType" color="#1989fa" class="tabs" @click="tabClick">
      <!-- <van-tab title="建设单位(企业)" name="企业"></van-tab>
      <van-tab title="建设单位(个人)" name="个人"></van-tab> -->
      <van-tab :title="tab.name" :name="tab.accountType" v-for="(tab,t) in loginConfig.register" :key="t"></van-tab>
    </van-tabs>
    <van-form @submit="onSubmit" class="form">
    <!-- <van-form class="form"> -->
      <van-field
        v-model="fromData.loginName"
        required
        label="用户名"
        placeholder="请输入用户名"
        :rules="[{ required: true, message: '请填写用户名' }]"
        @blur="checkValue('loginName')"
        />
      <van-field
        v-model="fromData.password"
        required
        type="password"
        label="密码"
        placeholder="请输入密码"
        :rules="[{ required: true, message: '请填写密码' }]"
        />
      <van-field
        v-model="fromData.password2"
        required
        type="password"
        label="确认密码"
        placeholder="请再次输入密码"
        :rules="[{ required: true, message: '请填写密码' }]"
        />
      <van-field v-if="tabConfig.accountType=='企业'"
        v-model="fromData.DWMC"
        required
        label="单位名称"
        placeholder="请输入单位名称"
        :rules="[{ required: true, message: '请填写单位名称' }]"
        @blur="checkValue('DWMC')"
        />
      <van-field v-if="tabConfig.accountType=='企业'"
        v-model="fromData.FRSFZH"
        required
        label="统一社会信用代码"
        placeholder="请输入统一社会信用代码"
        :rules="[{ required: true, message: '请填写统一社会信用代码' }]"
        @blur="checkValue('FRSFZH')"
        />
      <van-field v-if="tabConfig.registerConfig.email.show"
        v-model="fromData.mailBox"
        :required="tabConfig.registerConfig.email.requie"
        label="电子邮箱"
        placeholder="请输入电子邮箱"
        :rules="tabConfig.registerConfig.email.requie ? [{ required: true, message: '请填写电子邮箱' }] : []"
        @blur="checkValue('mailBox')"
        />
      <van-field v-if="tabConfig.registerConfig.phone.show"
        v-model="fromData.mobilePhone"
        :required="tabConfig.registerConfig.phone.requie"
        label="联系方式"
        placeholder="请输入联系方式"
        :rules="tabConfig.registerConfig.phone.requie ? [{ required: true, message: '请填写联系方式' }] : []"
      />
      <van-field v-if="tabConfig.userInfoChangeCheck=='phone'"
        v-model="fromData.validate"
        required
        center
        clearable
        label="验证码"
        placeholder="请输入短信验证码"
        :rules="[{ required: true, message: '请填写验证码' }]"
      >
        <template #button>
          <span class="code" @click="sendCode">发送验证码</span>
        </template>
      </van-field>
      <div class="btn-group">
        <van-button round block type="info" native-type="submit">注册</van-button>
        <!-- <van-button round block type="info" @click="onSubmit">注册</van-button> -->
        <div class="text-btn">
          <van-checkbox icon-size="16" v-model="checkbox" shape="square">我已仔细阅读并同意《服务与隐私条款》</van-checkbox>
        </div>
      </div>
    </van-form>
    <ThirdParty v-if="loginConfig.isHaveThirdLogin=='1'" />
  </div>
</template>

<script>
import api from '@/utils/api/personCenter'
import MD5 from 'md5.js'
import ThirdParty from './components/third-party'
import moduleMixins from '@/mixins/moduleMixins'
export default {
  components: { ThirdParty },
  mixins: [moduleMixins],
  props: {},
  data() {
    return {
      loginConfig: {},
      tabConfig: {
        registerConfig: {
          phone: {},
          email: {}
        }
      },
      fromData: {
        accountType: '企业',
        loginName: '',
        password: '',
        password2: '',
        DWMC: '',
        FRSFZH: '',
        mailBox: '',
        mobilePhone: '',
        validate: '',
      },
      num: 60,
      checkbox : ''
    };
  },
  watch: {},
  computed: {
    navTitle() {
      return '注册'
    }
  },
  methods: {
    tabClick(name) {
      console.log(name)
      this.tabConfig = this.loginConfig.register.filter(item => item.name.includes(name))[0]
    },
    checkValue(key) {
      let keyMap = {
        mobilePhone: 'MOBILEPHONE',
        loginName: 'LOGINNAME',
        DWMC: 'DWMC',
        mailBox: 'MAILBOX',
        ZJHM: 'ZJHM',
        FRSFZH: 'IDNUMBER'
      }
      console.log(this.fromData[key])
      // 检测参数value是否存在
      api.checkRegisterInfo({
        key: keyMap[key],
        value: this.fromData[key]
      }).then(res => {
        if(res.code != 0) {
          this.$toast(res.message)  
        }
      }).catch(err => {
        this.$toast(err.response.data.message)
      })
    },
    sendCode() {
      if(this.num!=60) return
      if(!this.fromData.mobilePhone) {
        this.$toast('请输入手机号')
        return
      }
      api.sendVerification({
        mobileNo: this.fromData.mobilePhone
      }).then(() => {
        this.$toast('发送成功')
        let timer = setInterval(()=> {
          this.num--
          if(this.num <= 0) {
            clearInterval(timer)
            this.num = 60
          }
        }, 1000)
      })
    },
    onSubmit() {
      if(!this.checkbox) {
        this.$toast('请仔细阅读并勾选同意协议')
        return
      }
      this.register()
    },
    register() {
      let params = {
        accountType: this.fromData.accountType,
        loginName: this.fromData.loginName,
        password: new MD5().update(this.fromData.password).digest('hex'),
      }
      if(this.tabConfig.type==2) {
        params.DWMC = this.fromData.DWMC
        params.FRSFZH = this.fromData.FRSFZH
      }
      if(this.tabConfig.registerConfig.email.show) {
        params.mailBox = this.fromData.mailBox
      }
      if(this.tabConfig.registerConfig.phone.show) {
        params.mobilePhone = this.fromData.mobilePhone
      }
      if(this.tabConfig.userInfoChangeCheck=='phone') {
        params.validate = this.fromData.validate
      }
      if(Object.prototype.hasOwnProperty.call(this.tabConfig, 'defaultValue')) {
        params = Object.assign(params, this.tabConfig.defaultValue)
      }
      console.log(params)
      api.register(params).then(() => {
        this.$toast.success('注册成功')
        setTimeout(() => {
          this.$router.push({ name: 'Login' })
        }, 2000)
      }).catch(err => {
        this.$toast(err.response.data.message)
      })
    },
    // 获取登录、注册页面配置
    getLoginCofig() {
      api.getLoginConfig().then(res => {
        console.log(res)
        this.loginConfig = res.data
        this.tabConfig = this.loginConfig.register[0]
        this.fromData.accountType = this.tabConfig.accountType
      })
    },
  },
  created() {
    this.getLoginCofig()
  },
  mounted() {}
};
</script>
<style lang="scss" scoped>
.register {
  position: relative;
  .title {
    background-color: #f0f5fe;
    padding: 30px 20px;
    font-size: 22px;
    line-height: 1.5;
  }
  ::v-deep .tabs {
    .van-tab--active {
      color: #1d84ff;
    }
    .van-tabs__line {
      width: 30%;
    }
  }
  .form {
    padding: 20px;
    background-color: #fff;
    .van-cell {
      display: block;
      ::v-deep .van-field__label {
        width: 100%;
        padding-bottom: 5px;
      }
      .code {
        color: #4082F6;
        padding: 10px 15px;
      }
    }
    ::v-deep .van-field--error .van-field__control::placeholder {
      color: #c8c9cc;
    }
    .btn-group {
      margin-top: 30px;
      .text-btn {
        margin: 10px auto;
        font-size: 14px;
        display: flex;
        justify-content: center;
      }
    }
  }
}
</style>